import React, { useId } from "react";
import cx from "classix";
import styles from "./Banderas.module.scss";

// Banderas hechas a mano (SVG inline), estilo chip con esquinas redondeadas igual que el Canva.
// Compartidas por todas las láminas que necesiten mostrar países — no reimplementar por lámina.
// useId() evita colisión de ids si la misma bandera se renderiza más de una vez en la página.
// Componente Banderas (Fase A, bases del sistema): el tamaño (`.bandera`, alto = token
// --mk-bandera-alto + aspect-ratio 3/2) vive acá, aplicado siempre — `className` es solo para
// posicionamiento (top/left), nunca para pisar el tamaño. Para más de una bandera en fila, envolver
// en `<FilaBanderas>` (gap = 50% del ancho de una bandera, derivado del mismo token — nunca pegadas).
const RADIO_ESQUINA = 24;

export function FilaBanderas({ children, className, ...rest }) {
  return (
    <div className={cx(styles.fila, className)} {...rest}>
      {children}
    </div>
  );
}

export function BanderaChile({ className, ...rest }) {
  const clipId = useId();
  return (
    <svg viewBox="0 0 300 200" className={cx(styles.bandera, className)} role="img" aria-label="Chile" {...rest}>
      <clipPath id={clipId}>
        <rect width="300" height="200" rx={RADIO_ESQUINA} />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <rect width="300" height="200" fill="#fff" />
        <rect y="100" width="300" height="100" fill="#D52B1E" />
        <rect width="100" height="100" fill="#0039A6" />
        <path
          fill="#fff"
          d="M50,20 L57.05,40.29 L78.53,40.73 L61.41,53.71 L67.63,74.27 L50,62 L32.37,74.27 L38.59,53.71 L21.47,40.73 L42.95,40.29 Z"
        />
      </g>
    </svg>
  );
}

export function BanderaPeru({ className, ...rest }) {
  const clipId = useId();
  return (
    <svg viewBox="0 0 300 200" className={cx(styles.bandera, className)} role="img" aria-label="Perú" {...rest}>
      <clipPath id={clipId}>
        <rect width="300" height="200" rx={RADIO_ESQUINA} />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <rect width="300" height="200" fill="#fff" />
        <rect width="100" height="200" fill="#D91023" />
        <rect x="200" width="100" height="200" fill="#D91023" />
      </g>
    </svg>
  );
}
